<template>
<div>
  <div class="product-footer">
    <div class="green">
      <div class="social-media">
        <a href="https://www.youtube.com/@Kaleidologistics" target="_blank">
          <i class="fa fa-3x fa-youtube-play" />
        </a>
        <a href="https://es.linkedin.com/company/kaleido-tech" target="_blank">
          <i class="fa fa-3x fa-linkedin-square"/>
        </a>
      </div>
      <div class="menu">
        <a href="https://kaleidotechnology.com/products" target="_blank">
          {{ $t('products') }}
        </a>
        <a href="https://kaleidotechnology.com/services" target="_blank">
          {{ $t('services') }}
        </a>
        <a href="https://kaleidotechnology.com/digitalization" target="_blank">
          {{ $t('digitalization') }}
        </a>
        <router-link to="contact">
          {{ $t('contact') }}
        </router-link>
      </div>
      <div class="logo">
        <a href="https://kaleidotechnology.com/products" target="_blank">
          <img src="/static/img/ktech.svg" alt="KaleidoTech">
        </a>
      </div>
    </div>
  </div>
  <div class="politics">
    <router-link to="privacy-policy">
      {{ $t('privacy_policy') }}
    </router-link>
    <router-link to="terms-conditions">
      {{ $t('terms_conditions') }}
    </router-link>
  </div>
</div>

</template>

<script>
export default {
  name: 'product'
}
</script>

<style lang="scss" scope>
@import '../../assets/scss/variables.scss';
.product-footer {
  .green {
    background: $k-lime;
    height: 3em;
    display: flex;
    align-items: center;
    padding: .5em 1em;
    .menu {
      flex: 1;
      text-transform: uppercase;
      text-align: center;
      a {
        font-family: MuseoSans-900;
        color: $k-black;
        padding: .3em .5em;
        margin: 0 .5em;
      }
    }
    .logo {
      max-width: 10em;
      filter: brightness(.1);
      opacity: .8;
      min-width: 3em;
    }
    .social-media {
      a {
        margin: 0 .5em;
        color: $k-black;
      }
    }
  }
}
.politics {
  display: flex;
  background: white;
  text-transform: uppercase;
  justify-content: center;
  a{
    margin: .7em 3em;
    color: $k-black;
    font-family: MuseoSans-500;
  }
}

@media screen and (max-width: 1050px) {
  .product-footer .green{
  .menu {
    a {
      padding: .3em .5em;
      margin: 0 .5em;
    }
  }
  }
}
@media screen and (max-width: 800px) {
  .product-footer .green{
  .menu {
    display: flex;
    flex-wrap: wrap;
    min-width: 16em;
    justify-content: center;
    a {
      padding: .1em .5em;
    }
  }
  .social-media {
    a {
      margin: .1em
    }
  }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/product/ProductFooter.vue